export default [
  {
    key: 'id',
    title: '任务ID',
    fixed: 'left',
    width: 46
  },
  {
    key: 'taskName',
    title: '任务名称',
    width: 108,
    overflow: true
  },
  {
    key: 'taskType',
    title: '任务类型',
    width: 56
  },
  {
    key: 'taskCnt',
    title: '任务进度',
    width: 108,
    overflow: true
  },
  {
    key: 'opName',
    title: '提交人',
    width: 60
  },
  {
    key: 'taskStatus',
    title: '任务状态'
  },
  {
    key: 'addTime',
    title: '提交时间',
    width: 104
  },
  {
    key: 'control',
    title: '操作',
    width: 104
  }
]
